import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;

class CategoryService {
  static fetch(originParams) {
    const params = {
      ...{ page_size: 1000 },
      ...originParams,
    };
    return request.get(`${apiUrlV1}/store_category/`, { params });
  }
}

export default CategoryService;
